import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { SubscriptionCategory } from '@subscriptions/interfaces/subscription-category';
import moment from 'moment';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import _ from 'lodash';
import { Contact } from '@contacts/interfaces/contact';

library.add(faPlus);

@Component({
  name: 'bpc-subscription-to-shopping-cart-modal',
  components: {
    'bpc-confirmation-modal': ConfirmationModal,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class AddSubscriptionToShoppingCartModal extends Vue {
  @Prop(Object) readonly selectedSubscriptionToBuy: SubscriptionCategory;
  @Prop(Array) readonly contacts: Contact[];

  public contactsToBuySubscription: number[] = [];
  public addingSubscriptionToShoppingCart: boolean = false;
  public createSubscriptionObservableSubscription = null;
  public addingSubscriptionToShoppingCartErrorText: string =
    'global.generic.error_adding_subscription_to_cart';
  public config: ConfirmationModalConfig = {
    id: 'buy-subscription-modal',
    title: this.$t('global.modals.subscription_categories.add_shopping_cart.title'),
    body: null,
    cancelText: this.$t('global.buttons.close') as string,
    acceptText: this.$t('global.buttons.confirm') as string,
  };

  get remainingSubscriptions() {
    return this.selectedSubscriptionToBuy?.remaining_subscriptions;
  }

  get availableToBuy() {
    return (
      _.isNull(this.selectedSubscriptionToBuy?.remaining_subscriptions) ||
      this.selectedSubscriptionToBuy?.remaining_subscriptions > 0
    );
  }

  get isUnlimited() {
    return _.isNull(this.selectedSubscriptionToBuy?.remaining_subscriptions);
  }

  get subscriptionName() {
    return this.selectedSubscriptionToBuy?.name;
  }

  get subscriptionDisciplines() {
    return this.selectedSubscriptionToBuy?.disciplines;
  }

  get disableAcceptButton() {
    return (
      this.addingSubscriptionToShoppingCart ||
      !this.availableToBuy ||
      (this.contacts?.length > 1 && this.contactsToBuySubscription?.length === 0) ||
      (!this.isUnlimited &&
        this.contacts?.length > 1 &&
        this.contactsToBuySubscription?.length >
          this.selectedSubscriptionToBuy?.remaining_subscriptions) ||
      (!this.isUnlimited &&
        this.contacts?.length === 1 &&
        this.selectedSubscriptionToBuy?.remaining_subscriptions < 1)
    );
  }

  onOpenModal() {
    this.$bvModal.show(this.config.id);
  }
  onCloseModal() {
    this.$bvModal.hide(this.config.id);
    this.$emit('click-on-close');
  }

  subscriptionStartDate() {
    return this.selectedSubscriptionToBuy['start_date_type'] === 'fixed_date'
      ? this.selectedSubscriptionToBuy.fixed_start_date
      : moment(new Date()).format('YYYY-MM-DD');
  }

  subscriptionEndDate() {
    switch (this.selectedSubscriptionToBuy['end_date_type']) {
      case 'fixed_date':
        return this.selectedSubscriptionToBuy.fixed_end_date;
      case 'fixed_duration':
        return moment(this.subscriptionStartDate())
          .add(
            this.selectedSubscriptionToBuy.fixed_duration_number,
            this.selectedSubscriptionToBuy['duration_type'],
          )
          .subtract(1, 'day')
          .format('YYYY-MM-DD');
      case 'without_end_date':
        return null;
    }
  }

  public formatDate(date): string {
    if (date) {
      return moment(String(date)).format('DD/MM/YYYY');
    }
  }

  addSubscriptionToShoppingCart() {
    this.addingSubscriptionToShoppingCart = true;
    const data = {
      subscription_category_id: this.selectedSubscriptionToBuy.id,
      contact_id:
        this.contacts.length > 1
          ? this.contactsToBuySubscription
          : [this.$authorizationService.getContactId()],
      creator_contact_id: this.$authorizationService.getContactId(),
      start_date: this.subscriptionStartDate(),
      end_date: this.subscriptionEndDate(),
      status: 'requested',
      total_credits: this.selectedSubscriptionToBuy.number_credits,
      remaining_credits: this.selectedSubscriptionToBuy.number_credits,
      form_config_name: 'public',
      online_subscription: true,
      // terms_and_conditions_accepted: this.$refs.stdForm.formModel.terms_and_conditions_accepted,
    };
    this.createSubscription(data);
  }

  createSubscription(data: AnyEntity) {
    const saveEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('subscription')}/bulk-store`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.post(saveEntityPath, data);

    if (this.createSubscriptionObservableSubscription) {
      this.createSubscriptionObservableSubscription.unsubscribe();
    }
    this.createSubscriptionObservableSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.addingSubscriptionToShoppingCart = false;
        this.$emit('success-subscription-creation', res.data);
      },
      error => {
        this.addingSubscriptionToShoppingCart = false;
        this.onCloseModal();
        this.$bpcMessage.showErrorMessage({ text: this.addingSubscriptionToShoppingCartErrorText });
      },
    );
  }

  public addContactToSubscription($event) {
    if ($event.target.checked) {
      if (!this.contactsToBuySubscription.includes($event.target.value)) {
        this.contactsToBuySubscription.push($event.target.value);
      }
    } else {
      if (this.contactsToBuySubscription.includes($event.target.value)) {
        const index = this.contactsToBuySubscription.indexOf($event.target.value);
        if (index > -1) {
          this.contactsToBuySubscription.splice(index, 1);
        }
      }
    }
  }
}
